import type { VerificationStatus, VerificationNames } from "shared/types";

export enum Flow {
  Default = "DEFAULT",
  BypassHomeScreen = "BypassHomeScreen"
}

export enum OtherScreens {
  Invite = "invite",
  MoveInDate = "moveInDate",
  CheckOut = "checkout",
  NotFound = "notFound",
  // When user cannot access the page
  // Could be because it's already submitted
  // Or user doesn't have application with the given ID
  NotAllowed = "notAllowed",
  ToApplications = "toApplications",
  Requirements = "requirements",
  PlaidError = "plaidError",
  IDVRequiredWaitForIt = "idvRequiredWaitForIt"
}

export type FlowScreens = VerificationNames | OtherScreens;

// Verification with steps.
export type GenericVerification = {
  name: VerificationNames;
  status: VerificationStatus;
  description: string;
  editable: boolean;
  estimated_time: number;
  id: number;
  index: number;
  progress?: {
    total_steps: number;
    filled_steps: number;
  };
  steps?: {
    id: number;
    name: string;
    index: number;
  }[];
  title: string;
};
